export class ComboDto {
  value: number;
  text: string;

  constructor(value: number, text: string) {
    this.value = value;
    this.text = text;
  }
}
